import React from 'react';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { spmfcloudFunctionUrl } from '../../actions/salesforces';
import { describeBeneficiaryObject } from './Beneficiary/actions';
import { describeFundRequestObject } from './Receipt/actions';
import AgencyInfo from './AgencyInfo';
import { getBeneficiaryCount, getApplicationsCount, getTotalFund } from './DashBoard/actions';
import ReportReceipt from './DashBoard/ReportReceipt';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dashboardData: {},
            agencyInfoData: {},
            helpText: {},
        };
        // these function are to get Bene. count,application count and receipt total for household user.
        this.getBeneficiaryCount = getBeneficiaryCount.bind(this);
        this.getApplicationsCount = getApplicationsCount.bind(this);
        this.getTotalFund = getTotalFund.bind(this);
    }

    async componentWillMount() {
        this.setState({ loading: true });
        const { loggedInUser } = this.props.user;
        const fetchOption = {
            headers: {
                'hash-token': this.props.user.siteToken.hash,
            },
            cache: 'default',
        };
        // / changes as per household and partner condition
        if (loggedInUser.Partner_Authority__c !== null) {
            try {
                const dashboardData = await fetch(`${spmfcloudFunctionUrl}/dashboard`, fetchOption)
                    .then(response => response.json());
                const agencyInfoData = await fetch(`${spmfcloudFunctionUrl}/sobject/Account/${this.props.user.loggedInUser.AccountId}`, fetchOption)
                    .then(response => response.json());
                const DesAgencyInfoData = await fetch(`${spmfcloudFunctionUrl}/sobject/Account/describe`, fetchOption)
                    .then(response => response.json());
                const fieldsDes = DesAgencyInfoData.result.fields || []
                const HelpText = {}
                fieldsDes.forEach(element => {
                    HelpText[element.name] = element.inlineHelpText
                });
                    console.log(DesAgencyInfoData.result.fields,'hereeee')
                    console.log(HelpText,'hereeee')
                this.setState({ loading: false, dashboardData, agencyInfoData: agencyInfoData.result, helpText: HelpText });
            } catch (error) {
                swal({
                    title: 'An error occured when getting dashboard data',
                    text: error.toString(),
                });
                this.setState({ loading: false });
            }
            // moved here because it was not showing labels in fund request detail
            await this.props.describeBeneficiaryObject();
            await this.props.describeFundRequestObject();
            await this.props.describeBeneficiaryObject();
            await this.props.describeFundRequestObject();
            const beneficiaryCount = await this.getBeneficiaryCount(this.props.user.siteToken, this.props.user.loggedInUser.AccountId);
            const totalApplication = await this.getApplicationsCount(this.props.user.siteToken, this.props.user.loggedInUser.AccountId);
            const getTotalFund = await this.getTotalFund(this.props.user.siteToken, this.props.user.loggedInUser.AccountId);
            const agencyInfoData = await fetch(`${spmfcloudFunctionUrl}/sobject/Account/${this.props.user.loggedInUser.AccountId}`, fetchOption)
                .then(response => response.json());
            this.setState({ loading: false, dashboardData: { beneficariesCount: beneficiaryCount.records.length, totalApplication: totalApplication.records.length, totalFunded: this.getTotalAmount(getTotalFund) }, agencyInfoData });
        }
    }
    componentDidMount() {
        console.log('componentDidMount', this.props.frObjectInfo.map(obj => obj.name).sort())
    }
    getTotalAmount(fund) {
        let finalFund = 0;
        if (fund.records === undefined) {
            return 0;
        }
        const fundRecordLength = fund.records.length;
        if (fundRecordLength > 0) {
            for (let i = 0; i < fundRecordLength; i++) {
                finalFund += fund.records[i].Approved_Amount__c;
            }
        }
        return finalFund;
    }


    render() {
        const { dashboardData, loading, agencyInfoData, helpText } = this.state;
        if (loading) {
            return <p style={{ textAlign: 'center' }}><i className="fa fa-3x fa-spinner fa-spin" /></p>;
        }
        return (
            <div>
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="card">
                            <div className="content">
                                <div className="row">
                                    <div className="col-xs-5">
                                        <div className="icon-big icon-warning text-center">
                                            <i className="ti-user" />
                                        </div>
                                    </div>
                                    <div className="col-xs-7">
                                        <div className="numbers">
                                            <p>Beneficiaries</p> {dashboardData.beneficariesCount}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <hr />
                                    <div className="stats">
                                        <i className="ti-reload" /> {moment(dashboardData.timeIssued).fromNow(true)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <div className="card">
                            <div className="content">
                                <div className="row">
                                    <div className="col-xs-5">
                                        <div className="icon-big icon-success text-center">
                                            <i className="ti-wallet" />
                                        </div>
                                    </div>
                                    <div className="col-xs-7">
                                        <div className="numbers">
                                            <p>Funded</p> ${dashboardData.totalFunded ? dashboardData.totalFunded.toLocaleString() : 0}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <hr />
                                    <div className="stats">
                                        <i className="ti-calendar" /> {moment(dashboardData.timeIssued).fromNow(true)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <div className="card">
                            <div className="content">
                                <div className="row">
                                    <div className="col-xs-5">
                                        <div className="icon-big icon-danger text-center">
                                            <i className="ti-pulse" />
                                        </div>
                                    </div>
                                    <div className="col-xs-7">
                                        <div className="numbers">
                                            <p>Applications</p> {dashboardData.totalApplication}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <hr />
                                    <div className="stats">
                                        <i className="ti-timer" /> {moment(dashboardData.timeIssued).fromNow(true)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.user.loggedInUser.Partner_Authority__c !== null ?
                    (
                        <AgencyInfo
                            data={dashboardData}
                            agencyData={agencyInfoData}
                            helpText={helpText}
                        />
                    ) : null}
                <div className="clearfix" />
                <ReportReceipt
                    hashToken={this.props.user.siteToken.hash}
                />
            </div>
        );
    }
}

Dashboard.propTypes = {
    user: PropTypes.object.isRequired,
    describeBeneficiaryObject: PropTypes.func.isRequired,
    describeFundRequestObject: PropTypes.func.isRequired,
};

Dashboard.defaultProps = {

};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        describeBeneficiaryObject,
        describeFundRequestObject
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    frObjectInfo: state.objectInfo.Fund_Request__c,
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Dashboard.js
// module id = 986
// module chunks = 0